import { createContext, useContext } from 'react';
import LocalStorage from '../Services/Persistence/LocalStorage';
import TokenStore from '../Stores/TokenStore';
import { useStoreUpdate, useStoreValue } from '@cb/solaris-react/Utility/Store';
const TokenStoreContext = createContext(new TokenStore(new LocalStorage()));
export function useTokenStore() {
    const tokenStore = useContext(TokenStoreContext);
    return tokenStore;
}
export function useTokenData() {
    const tokenStore = useTokenStore();
    const isTokenLoading = useStoreValue(tokenStore, 'isLoading');
    const tokenData = useStoreValue(tokenStore, 'tokenData');
    const setTokenData = useStoreUpdate(tokenStore, 'tokenData');
    return { tokenData, setTokenData, isTokenLoading };
}
//# sourceMappingURL=UseTokenStore.js.map